import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
    static targets = ['globallyEnabled', 'campaignList']

    declare readonly globallyEnabledTarget: HTMLInputElement
    declare readonly campaignListTarget: HTMLInputElement

    connect() {
        window.multi_select.init({
            selectableHeader: `<div class="input-group mb-2">
                <input type="text" class="search-input form-control" autocomplete="off" placeholder="Search">
                <button type="button" class="btn btn-danger btn-no-click">
                    Disabled
                    <i class="ms-1 fa fa-times"></i>
                </button>

                <button type="button" class="allow-all btn btn-light"><i class="fa fa-angle-double-right"></i></button>
            </div>`,
            selectionHeader: `<div class="input-group mb-2">
                <button type="button" class="remove-all btn btn-light"><i class="fa fa-angle-double-left"></i></button>
                <button type="button" class="btn btn-success btn-no-click">
                    <i class="me-1 fa fa-check"></i>
                    Enabled
                </button>
                <input type="text" class="search-input form-control" autocomplete="off" placeholder="Search">
            </div>`,
        })

        this.toggleCampaignList()
    }

    toggleCampaignList() {
        this.campaignListTarget.style.display = this.globallyEnabledTarget.checked
            ? 'none'
            : 'block'
    }
}
